import axios from 'axios';
import { store } from '../main';

export const flomV1 = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL_OLD,
  timeout: 30000,
});

flomV1.interceptors.request.use((config) => {
  const token = store.getState().authorization.flom.accessToken;
  if (token) {
    config.headers['access-token'] = token;
  }

  return config;
});

export const createFileUrlV1 = (nameOnServer) => {
  if (typeof nameOnServer === 'string' && nameOnServer.length > 0) {
    return process.env.REACT_APP_BASE_URL_OLD + '/uploads/' + nameOnServer;
  }
  return null;
};

export const createEmojiUrl = (nameOnServer) => {
  if (typeof nameOnServer === 'string' && nameOnServer.length > 0) {
    return process.env.REACT_APP_BASE_URL_OLD + '/uploads/emojis/' + nameOnServer;
  }
  return null;
};
